import { render, staticRenderFns } from "./ProductEditExtraFields.vue?vue&type=template&id=0a867b5b"
import script from "./ProductEditExtraFields.vue?vue&type=script&lang=ts"
export * from "./ProductEditExtraFields.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0a867b5b')) {
      api.createRecord('0a867b5b', component.options)
    } else {
      api.reload('0a867b5b', component.options)
    }
    module.hot.accept("./ProductEditExtraFields.vue?vue&type=template&id=0a867b5b", function () {
      api.rerender('0a867b5b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/products/ProductEditExtraFields.vue"
export default component.exports